var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoEventsCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 322.229,
    height: 319.378,
    viewBox: "0 0 322.229 319.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154485",
    "data-name": "Rectangle 154485",
    width: 322.229,
    height: 319.378,
    transform: "translate(0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187587",
    "data-name": "Group 187587",
    transform: "translate(36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187586",
    "data-name": "Group 187586",
    transform: "translate(-36)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37662",
    "data-name": "Path 37662",
    d: "M322.229,265.5c0,5.515-64.293,9.985-143.6,9.985s-143.6-4.47-143.6-9.985,64.293-9.985,143.6-9.985,143.6,4.47,143.6,9.985",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37663",
    "data-name": "Path 37663",
    d: "M230.418,86.166q-.756-.025-1.51-.038A46.514,46.514,0,0,1,192.065,66.4,78.277,78.277,0,0,0,62.859,154.731c7.632,11.707,11.129,25.536,11.015,39.51q-.015,1.8.08,3.63a58.431,58.431,0,0,0,79.138,51.445c14.808-5.656,31.139-6.487,46.049-1.108A83.521,83.521,0,1,0,230.418,86.166",
    fill: "#fbf2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37664",
    "data-name": "Path 37664",
    d: "M106.654,180.839a83.315,83.315,0,0,0-10.5-18.66c-16.743,12.2-35.776,17.518-36.408,8.209-.628-9.27,22.432-11.312,29.964-16.071a97.96,97.96,0,0,0-13.986-12.686c-7.792,7.15-13.636,17.21-16.739,12.929C54.825,148.824,68.52,143.565,71.1,138.4a88.154,88.154,0,0,0-18.172-9.118c-5.058,7.818-7.067,16.946-10.58,14.24-4.581-3.529,5.221-10.576,6.374-15.641a83.94,83.94,0,0,0-31.565-3.3A86.836,86.836,0,0,0,7.066,142.41c5.073,2.878,22.536-1.317,22.67,7.436.1,6.308-13.565.938-25.219-.831A83.54,83.54,0,0,0,.343,167.88c2.641.827,24.694-9.612,28.288,1.9C30.823,176.8,12.582,175.755,0,176.563a69.141,69.141,0,0,0,3.523,20.519c.285-.352.461-.559.461-.559s19.655-18.473,27.73-7.8c4.5,5.948-13.376,11.308-25.036,16.244.206.438.41.877.627,1.316a77.565,77.565,0,0,0,12.547,18.747c.3-.593.5-.965.5-.965s16.589-33.11,28.723-27.472c9.337,4.339-6.695,25.042-22.366,34.579a35.176,35.176,0,0,0,19.244,7.146c4.065-3.431,6.413-23.476,15.837-20.461,4.973,1.591-2.651,10.134-6.948,19.7A41.123,41.123,0,0,0,75.5,225.541a88.084,88.084,0,0,1,6.923,33.766l9.791-4.91S91.642,239.8,81.146,223.58a55.724,55.724,0,0,0,17.021-7.358c-10.434-2.255-22.236-1.264-20.492-6.334,3.862-11.221,25.213-.216,28.19-1.042a22.254,22.254,0,0,0,4.091-13.23,32.722,32.722,0,0,0-.784-6.573c-12.456,1.9-30,6.83-29.364-.485.992-11.495,23.708-5.965,26.846-7.719",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37665",
    "data-name": "Path 37665",
    d: "M285.99,132.687s-8.783,4.022-9.886,19.771-16.548,11.274-19.685,20.563-3.394,16.8-6.513,20.075-5.23,17.639-3.923,26.741c0,0,14.211-14.361,14.579-19.611s-1.538-15.463,5.193-19.931,14.129-6.47,15.356-14.886-1.566-25.613,4.879-32.722",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37666",
    "data-name": "Path 37666",
    d: "M170.811,75.395s-2.748,9.261,8.387,20.452-2.4,19.88,2.537,28.353,10.419,13.607,10.835,18.112,9.845,15.541,17.56,20.545c0,0-1.467-20.15-5.179-23.881s-12.659-9.014-11.6-17.023,4.421-14.9-1.109-21.358-20.322-15.669-21.435-25.2",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37667",
    "data-name": "Path 37667",
    d: "M223.249,56.654S216.242,63.3,220.3,78.561s-12.007,16.025-11.967,25.83,2.229,16.992.338,21.1.764,18.381,4.948,26.57c0,0,8.8-18.189,7.444-23.275s-6.463-14.132-1.541-20.539,11.272-10.7,9.709-19.056-9.776-23.726-5.98-32.539",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37668",
    "data-name": "Path 37668",
    d: "M265.893,93.773s-1.26-28.14,5.04-29.82,12.18,12.6-5.04,29.82",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37669",
    "data-name": "Path 37669",
    d: "M261.927,104.437s21.579-18.1,26.742-14.124-2.6,17.33-26.742,14.124",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37670",
    "data-name": "Path 37670",
    d: "M251.659,120.124S273.238,102.019,278.4,106s-2.6,17.33-26.742,14.124",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37671",
    "data-name": "Path 37671",
    d: "M241.857,132.251s26.1-10.6,29.789-5.219-7.8,15.691-29.789,5.219",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37672",
    "data-name": "Path 37672",
    d: "M233.093,147.641s26.1-10.6,29.789-5.219-7.8,15.691-29.789,5.219",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37673",
    "data-name": "Path 37673",
    d: "M260.511,104.358s-15.863-23.276-11.387-28.017,16.985,4.316,11.387,28.017",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37674",
    "data-name": "Path 37674",
    d: "M250.431,119.547S234.568,96.271,239.044,91.53s16.984,4.316,11.387,28.017",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37675",
    "data-name": "Path 37675",
    d: "M241.755,132.823s-19.644-20.188-16.054-25.63,17.475,1.319,16.054,25.63",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37676",
    "data-name": "Path 37676",
    d: "M233.451,146.527s-19.559-20.263-16.4-25.327,16.652,2.051,16.4,25.327",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37677",
    "data-name": "Path 37677",
    d: "M226.064,158.48s27.133-7.565,30.189-1.8-11.145,8.522-30.189,1.8",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37678",
    "data-name": "Path 37678",
    d: "M221.539,168.721s31.413-4.618,34.014,2.256-13.669,7.952-34.014-2.256",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37679",
    "data-name": "Path 37679",
    d: "M226.408,159.144s-19.559-20.263-16.4-25.327,16.652,2.051,16.4,25.327",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37680",
    "data-name": "Path 37680",
    d: "M221.539,168.75s-22.8-16.53-20.571-22.069,16.753-.893,20.571,22.069",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37681",
    "data-name": "Path 37681",
    d: "M269.883,81.173s-5.04,23.185-18.224,38.951c-10.413,12.453-28.344,40.639-33.62,58.909a98.711,98.711,0,0,0-3.806,33.389",
    fill: "none",
    stroke: "#c8d5ff",
    strokeWidth: 2.688
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37682",
    "data-name": "Path 37682",
    d: "M80.922,103.252S58.714,78.193,63.278,71.929s20.677,2.534,17.644,31.323",
    fill: "#61277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37683",
    "data-name": "Path 37683",
    d: "M85.232,116.072s6.4-32.866,14.148-33.049,10.556,17.959-14.148,33.049",
    fill: "#61277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37684",
    "data-name": "Path 37684",
    d: "M87.475,138.245s6.4-32.866,14.148-33.049,10.556,17.959-14.148,33.049",
    fill: "#61277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37685",
    "data-name": "Path 37685",
    d: "M87.487,156.781s16.193-29.308,23.622-27.1,4.525,20.335-23.622,27.1",
    fill: "#61277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37686",
    "data-name": "Path 37686",
    d: "M90.9,177.555s16.193-29.308,23.622-27.1,4.525,20.335-23.622,27.1",
    fill: "#4671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37687",
    "data-name": "Path 37687",
    d: "M83.865,117.057S51.8,107.413,52.391,99.686s18.922-8.713,31.474,17.371",
    fill: "#61277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37688",
    "data-name": "Path 37688",
    d: "M85.909,138.63s-32.065-9.645-31.474-17.372,18.922-8.713,31.474,17.372",
    fill: "#61277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37689",
    "data-name": "Path 37689",
    d: "M87.821,157.385s-33.248-3.962-34-11.676,17.134-11.849,34,11.676",
    fill: "#61277F",
    stroke: "#61277F",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37690",
    "data-name": "Path 37690",
    d: "M90.4,176.258s-33.226-4.1-34.089-11.142,16.92-10.557,34.089,11.142",
    fill: "#61277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37691",
    "data-name": "Path 37691",
    d: "M92.509,192.827s19.414-27.281,26.545-24.244-3.925,16.209-26.545,24.244",
    fill: "#4671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37692",
    "data-name": "Path 37692",
    d: "M95.986,205.673s25.572-27.758,33.116-23.352-6.684,17.57-33.116,23.352",
    fill: "#4671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37693",
    "data-name": "Path 37693",
    d: "M93.322,193.183s-33.226-4.1-34.089-11.142,16.92-10.557,34.089,11.142",
    fill: "#61277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37694",
    "data-name": "Path 37694",
    d: "M96.007,205.7s-33.431,1.778-35.512-5.008,14.813-13.354,35.512,5.008",
    fill: "#61277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37695",
    "data-name": "Path 37695",
    d: "M75.186,88.626s12.681,25.192,12.289,49.619c-.309,19.294,4.2,58.747,12.988,79.574a117.346,117.346,0,0,0,21.453,33.7",
    fill: "none",
    stroke: "#61277F",
    strokeWidth: 3.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37696",
    "data-name": "Path 37696",
    d: "M254.232,259.568H75.15L105.6,129.695h164.3Z",
    fill: "#61277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37697",
    "data-name": "Path 37697",
    d: "M307.467,269.263h-164.3L105.6,129.7h164.3Z",
    fill: "#fbf2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37698",
    "data-name": "Path 37698",
    d: "M313.572,269.263H149.27L111.71,129.7h164.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37699",
    "data-name": "Path 37699",
    d: "M171.409,200.156H148.1l-5.328-19.8h23.306Z",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37700",
    "data-name": "Path 37700",
    d: "M199.5,200.156H176.191l-5.328-19.8h23.306Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37701",
    "data-name": "Path 37701",
    d: "M227.584,200.156H204.278l-5.328-19.8h23.306Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37702",
    "data-name": "Path 37702",
    d: "M255.672,200.156H232.366l-5.328-19.8h23.306Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37703",
    "data-name": "Path 37703",
    d: "M283.759,200.156H260.452l-5.327-19.8h23.306Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37704",
    "data-name": "Path 37704",
    d: "M178.083,227.092H154.776l-5.327-19.8h23.306Z",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37705",
    "data-name": "Path 37705",
    d: "M206.171,227.092H182.864l-5.327-19.8h23.306Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37706",
    "data-name": "Path 37706",
    d: "M234.258,227.092H210.952l-5.328-19.8H228.93Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37707",
    "data-name": "Path 37707",
    d: "M262.345,227.092H239.039l-5.328-19.8h23.306Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37708",
    "data-name": "Path 37708",
    d: "M290.433,227.092H267.127l-5.328-19.8H285.1Z",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37709",
    "data-name": "Path 37709",
    d: "M184.863,253.559H161.556l-5.327-19.8h23.306Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37710",
    "data-name": "Path 37710",
    d: "M212.95,253.559H189.643l-5.328-19.8h23.307Z",
    fill: "#c8d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37711",
    "data-name": "Path 37711",
    d: "M241.038,253.559H217.732l-5.328-19.8H235.71Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37712",
    "data-name": "Path 37712",
    d: "M269.125,253.559H245.819l-5.328-19.8H263.8Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37713",
    "data-name": "Path 37713",
    d: "M297.212,253.559H273.906l-5.328-19.8h23.306Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37714",
    "data-name": "Path 37714",
    d: "M285.675,165.6l-9.663-35.906H111.71l9.663,35.906Z",
    fill: "#61277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37715",
    "data-name": "Path 37715",
    d: "M142.775,144.358c0,2.841-1.77,5.145-3.954,5.145s-3.954-2.3-3.954-5.145,1.771-5.145,3.954-5.145,3.954,2.3,3.954,5.145",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37716",
    "data-name": "Path 37716",
    d: "M137.8,144.441h0A2.372,2.372,0,0,1,139.367,142c4.66-1,8.2-6.4,8.006-12.8s-4.268-11.718-9.2-11.967c-5.455-.275-9.961,5.421-9.961,12.46H124.4c0-10.27,6.859-18.494,14.929-17.324,6.136.89,11.1,7.345,11.781,15.33.816,9.513-4.292,17.732-11.127,19.2-1.148.246-2.185-.949-2.185-2.463",
    fill: "#fbf2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37717",
    "data-name": "Path 37717",
    d: "M171.967,144.358c0,2.841-1.77,5.145-3.955,5.145s-3.953-2.3-3.953-5.145,1.77-5.145,3.953-5.145,3.955,2.3,3.955,5.145",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37718",
    "data-name": "Path 37718",
    d: "M166.99,144.441h0A2.372,2.372,0,0,1,168.559,142c4.66-1,8.2-6.4,8.006-12.8s-4.269-11.718-9.2-11.967c-5.455-.275-9.961,5.421-9.961,12.46h-3.816c0-10.27,6.858-18.494,14.929-17.324,6.136.89,11.1,7.345,11.781,15.33.816,9.513-4.292,17.732-11.127,19.2-1.148.246-2.185-.949-2.185-2.463",
    fill: "#fbf2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37719",
    "data-name": "Path 37719",
    d: "M201.158,144.358c0,2.841-1.77,5.145-3.954,5.145s-3.953-2.3-3.953-5.145,1.77-5.145,3.953-5.145,3.954,2.3,3.954,5.145",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37720",
    "data-name": "Path 37720",
    d: "M196.181,144.441h0A2.372,2.372,0,0,1,197.75,142c4.66-1,8.2-6.4,8.006-12.8s-4.269-11.718-9.2-11.967c-5.455-.275-9.961,5.421-9.961,12.46h-3.816c0-10.27,6.858-18.494,14.929-17.324,6.136.89,11.1,7.345,11.781,15.33.816,9.513-4.292,17.732-11.127,19.2-1.148.246-2.185-.949-2.185-2.463",
    fill: "#fbf2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37721",
    "data-name": "Path 37721",
    d: "M230.35,144.358c0,2.841-1.77,5.145-3.954,5.145s-3.954-2.3-3.954-5.145,1.771-5.145,3.954-5.145,3.954,2.3,3.954,5.145",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37722",
    "data-name": "Path 37722",
    d: "M225.373,144.441h0A2.372,2.372,0,0,1,226.942,142c4.66-1,8.2-6.4,8.006-12.8s-4.268-11.718-9.2-11.967c-5.455-.275-9.961,5.421-9.961,12.46h-3.816c0-10.27,6.859-18.494,14.929-17.324,6.136.89,11.1,7.345,11.781,15.33.816,9.513-4.292,17.732-11.127,19.2-1.148.246-2.185-.949-2.185-2.463",
    fill: "#fbf2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37723",
    "data-name": "Path 37723",
    d: "M259.541,144.358c0,2.841-1.77,5.145-3.954,5.145s-3.953-2.3-3.953-5.145,1.77-5.145,3.953-5.145,3.954,2.3,3.954,5.145",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37724",
    "data-name": "Path 37724",
    d: "M254.564,144.441h0A2.371,2.371,0,0,1,256.133,142c4.66-1,8.2-6.4,8.006-12.8s-4.269-11.718-9.2-11.967c-5.455-.275-9.961,5.421-9.961,12.46h-3.816c0-10.27,6.858-18.494,14.929-17.324,6.136.89,11.1,7.345,11.781,15.33.816,9.513-4.292,17.732-11.127,19.2-1.148.246-2.185-.949-2.185-2.463",
    fill: "#fbf2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37725",
    "data-name": "Path 37725",
    d: "M152.727,188.234a27.435,27.435,0,0,1,4.867,2.817c.185.135.383.265.556.416-.115-.1-.222-.176-.043-.03l.3.242q.537.439,1.052.907a27.442,27.442,0,0,1,2.009,2.027,2.029,2.029,0,0,0,2.851,0,2.059,2.059,0,0,0,0-2.85,28.735,28.735,0,0,0-9.559-7.01,2.067,2.067,0,0,0-2.758.723,2.038,2.038,0,0,0,.724,2.758",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37726",
    "data-name": "Path 37726",
    d: "M162.476,184.6a107.307,107.307,0,0,0-10.145,10.744,2.064,2.064,0,0,0,0,2.851,2.039,2.039,0,0,0,2.851,0,107.2,107.2,0,0,1,10.145-10.744,2.032,2.032,0,0,0,0-2.851,2.06,2.06,0,0,0-2.851,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37727",
    "data-name": "Path 37727",
    d: "M271.618,213.982a27.408,27.408,0,0,1,4.868,2.817c.185.135.384.265.556.416-.115-.1-.222-.176-.043-.03l.3.242q.537.439,1.052.907a27.646,27.646,0,0,1,2.01,2.027,2.028,2.028,0,0,0,2.85,0,2.06,2.06,0,0,0,0-2.85,28.746,28.746,0,0,0-9.559-7.01,2.067,2.067,0,0,0-2.758.723,2.038,2.038,0,0,0,.723,2.758",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37728",
    "data-name": "Path 37728",
    d: "M281.368,210.348a107.2,107.2,0,0,0-10.145,10.744,2.064,2.064,0,0,0,0,2.851,2.039,2.039,0,0,0,2.851,0A107.194,107.194,0,0,1,284.219,213.2a2.032,2.032,0,0,0,0-2.851,2.06,2.06,0,0,0-2.851,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_187588",
    "data-name": "Group 187588"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x2: 3.628,
    y2: 3.347,
    transform: "translate(156.314 216.153)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4.032
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    y1: 7.078,
    x2: 7.404,
    transform: "translate(159.942 212.422)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4.032
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_187590",
    "data-name": "Group 187590",
    transform: "translate(36.803 29.447)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_25-2",
    "data-name": "Line 25",
    x2: 3.628,
    y2: 3.347,
    transform: "translate(156.314 216.153)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4.032
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26-2",
    "data-name": "Line 26",
    y1: 7.078,
    x2: 7.404,
    transform: "translate(159.942 212.422)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4.032
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEventsCalendar);
export default __webpack_public_path__ + "static/media/no-events-calendar.003e0bf8fe57acfd0216ac1372a96e20.svg";
export { ForwardRef as ReactComponent };